import { Injectable } from '@angular/core';

@Injectable()
export class Data {

   public storage: any;

   public constructor() { }

}


// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/data.ts